export const logout = () => {
    localStorage.removeItem("member-admin-user");
    window.location.href = "/"
}